module.exports = __webpack_public_path__ + "static/media/pierre-2.1bb96eee.jpeg";